import { api } from "@/lib/api";

/**
 * Fire-and-forget analytics ping for the cover-photo cropper funnel.
 * Never throws — a failed analytics call must not block the UX flow it's
 * instrumenting. The backend accepts: opened, cancelled, confirmed,
 * upload_succeeded, upload_failed.
 */
export function trackCropperEvent(event) {
  try {
    // Deliberately not awaited — the caller shouldn't wait on analytics.
    api.post("/analytics/cover-cropper", { event }).catch(() => {
      /* non-fatal — swallow network / 4xx so the UI never sees it */
    });
  } catch {
    /* noop */
  }
}
